import {del, get, post, put} from "@/services/api"


const state = {
    subjects: [],
    didLoadSubjects: false,
    subject: { id: null, name: '', code: '', subjectUsers: [], imageId: null },
    subjectById: { id: null, name: '', code: '', subjectUsers: [], imageId: null },
    images: []
};

const getters = {
    getSubjects: state => state.subjects,
    getSubjectById: state => id => state.subjects.find(s => s.id === id),
    didLoadSubjects: state => state.didLoadSubjects,
    getSubject: state => state.subject,
    getImages: state => state.images,
};

const actions = {

    async fetchAllSubjects({commit}) {
        commit('startedDataDownload');
        await get('gamification/subjects/by_user')
            .then((subjects) => {
                commit('setSubjects', subjects.data.items)
            });
        commit('finishedDataDownload');

    },

    async fetchSubjectById({commit}, id) {
        commit('errors/clear', null, { root: true });
        commit('startedDataDownload');
        const response = await get('gamification/subjects/' + id);
        commit('updateSubject', response.data.content)
        commit('finishedDataDownload');
        return response.data.content
    },

    async createSubject({commit}, {item}) {
        const response = await post('gamification/subjects/', item);
        const newSubject = response.data.content;
        commit('addSubject', newSubject);
        return newSubject.id;
    },

    async deleteSubjectById({commit}, id) {
        await del(`gamification/subjects/${id}`)
            .then(() => {
                commit('filterSubjects', id);
            });
    },

    async updateSubject({commit}, {item}) {
        await put(`gamification/subjects/${item.id}`, item)
            .then((response) => {
                commit('updateSubject', response)
            });
    },
    setSubject({commit}, subject){ commit('setSubject', subject) },
    clearSubject({commit}, ){ commit('clearSubject') },
    async fetchImages({commit}){
        try {
            const response = await get('gamification/subjects/images')
            commit('setImages', response.data.items)

        } catch (e) {
            console.log('error ', e)
        }
    },
    updateSubjectUserLogin({commit}, {user, uisId}){
        commit('updateSubjectUserLogin', user, uisId)
    }
};

const mutations = {
    startedDataDownload: state => state.didLoadSubjects = false,
    finishedDataDownload: state => state.didLoadSubjects = true,
    setSubjects: (state, subjects) => (state.subjects = subjects),
    updateSubject: (state, item) => {
        const existing = state.subjects.findIndex(s => s.id === item.id);
        if (existing > -1) {
            state.subjects.splice(existing, 1, item)
        } else {
            state.subjects.push(item)
        }
    },
    updateSubjectById: (state, item) => (Object.assign(state.subjectById, item)),
    addSubject: (state, item) => (state.subjects.push(item)),
    filterSubjects: (state, id) => (state.subjects = state.subjects.filter(subjects => subjects.id !== id)),
    setSubject: (state, subject) => Object.assign(state.subject, subject),
    clearSubject: (state) => {
        state.subject.id = null
        state.subject.name = ''
        state.subject.code = ''
        state.subject.subjectUsers = []
        state.subject.imageId = null
    },
    setImages: (state, images) => (state.images = images),
    updateSubjectUserLogin: (state, uisId, login) => {
        const index = state.subject.subjectUsers.findIndex(su => su.uisId === uisId)
        if(index !== -1){
            state.subject.subjectUsers[index] = {
                ...state.subject.subjectUsers[index],
                login: login,
                active: true
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}